import type { DocumentStatus } from "@/modules/quotation-invoice/domain/types";
import { cn } from "@devhop/ui";

const LABELS: Record<DocumentStatus, string> = {
  draft: "ຮ່າງ",
  issued: "ອອກແລ້ວ",
  partially_paid: "ຊຳລະບາງສ່ວນ",
  paid: "ຊຳລະແລ້ວ",
  cancelled: "ຍົກເລີກ",
};

const COLOR_MAP: Record<DocumentStatus, string> = {
  draft:
    "border border-zinc-300 bg-zinc-100 text-zinc-600 dark:border-zinc-600 dark:bg-zinc-800 dark:text-zinc-300",
  issued:
    "border border-blue-300 bg-blue-50 text-blue-700 dark:border-blue-700 dark:bg-blue-950/60 dark:text-blue-300",
  partially_paid:
    "border border-amber-400 bg-amber-50 text-amber-700 dark:border-amber-600 dark:bg-amber-950/60 dark:text-amber-300",
  paid: "border border-emerald-400 bg-emerald-50 text-emerald-700 dark:border-emerald-600 dark:bg-emerald-950/60 dark:text-emerald-300",
  cancelled:
    "border border-red-300 bg-red-50 text-red-600 dark:border-red-700 dark:bg-red-950/60 dark:text-red-400",
};

export function DocumentStatusBadge({ status }: { status: string }) {
  const s = status as DocumentStatus;
  const label = LABELS[s] ?? status;
  const colorClass =
    COLOR_MAP[s] ??
    "border border-zinc-300 bg-zinc-100 text-zinc-600 dark:border-zinc-600 dark:bg-zinc-800 dark:text-zinc-300";

  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-2.5 py-0.5 font-medium text-xs",
        colorClass,
      )}
    >
      {label}
    </span>
  );
}
